import { PageEvent } from '@angular/material/paginator';
import { ParamMap } from '@angular/router';

export class Params {

  fantasyName: string;
  externalId: string;
  cpfCnpj: string;
  contactEmail: string;
  page: number;
  pageSize: number;

  constructor(params: ParamMap) {
    this.page = params.get('page') ? +params.get('page') : 1;
    this.pageSize = params.get('page_size') ? +params.get('page_size') : 20;
    this.fantasyName = params.get('fantasy_name');
    this.externalId = params.get('external_id');
    this.cpfCnpj = params.get('cpf_cnpj');
    this.contactEmail = params.get('contact_email');
  }

  setPagination(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.pageSize = event.pageSize;
  }

  setFilter(property: string, value: string, ...except: string[]) {
    Object.keys(this).forEach(key => {
      if (!except.includes(key)) {
        this[key] = key === property ? value : null;
      }
    });
  }

  createParams(...except: string[]) {
    const params: any = { };

    Object.entries(this).forEach(([key, value]) => {
      if (!except.includes(key) && value) {
        const snakeCase = this.toSnakeCase(key);
        params[snakeCase] = this[key];
      }
    });

    return params;
  }

  createPost() {
    const params = this.createParams('page', 'pageSize');
    params.rows_per_page = this.pageSize;
    params.page_number = this.page;

    return params;
  }

  resetPage() {
    this.page = 1;
  }

  resetFilter(...except: string[]) {
    Object.keys(this).forEach(key => {
      if (!except.includes(key)) {
        this[key] = null;
      }
    });
  }

  getSelectedFilters() {
    return {
      fantasy_name: {
        name: 'fantasy_name',
        value: this.fantasyName,
        type: 'fantasyName'
      },
      external_id: {
        name: 'external_id',
        value: this.externalId,
        type: 'externalId'
      },
      cpf_cnpj:{
        name: 'cpf_cnpj',
        value: this.cpfCnpj,
        type: 'cpfCnpj'
      },
      contact_email: {
        name: 'contact_email',
        value: this.contactEmail,
        type: 'contactEmail'
      }
    }
  }

  toSnakeCase(value: string) {
    return value.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
  }
}
